import { PartQuantity, SupplierPart } from "./partsCalculationUtils";

export type JoinedSupplierPartRow = {
  partId: string;
  partNumber: string;
  rootPartNumber: string;
  partName?: string;
  askedQty: number;
  stockQty: number;
  updatedAt?: number;
  supplierPart: SupplierPart & { id?: string };
};

export const joinSupplierPartRows = (
  remainingParts: PartQuantity[],
  supplierParts: Array<SupplierPart & { id?: string }>,
): JoinedSupplierPartRow[] => {
  const supplierPartsMap = new Map(
    supplierParts.map((part) => [part.rootPartNumber, part]),
  );

  return remainingParts.flatMap((orderPart) => {
    const matchingPart = supplierPartsMap.get(orderPart.rootPartNumber);
    if (!matchingPart) {
      return [];
    }

    const partId =
      orderPart.partId ||
      (matchingPart as { id?: string }).id ||
      orderPart.rootPartNumber;

    return [
      {
        partId,
        partNumber: orderPart.partNumber,
        rootPartNumber: orderPart.rootPartNumber,
        partName: orderPart.partName,
        askedQty: orderPart.quantity,
        stockQty: matchingPart.familyQuantity,
        updatedAt: matchingPart.updatedAt,
        supplierPart: matchingPart,
      },
    ];
  });
};
